/**
 * Owner: Masa Bayu
 * File: guards.ts
 * Date:Time: 2026-09-15 19:18
 * Description: Primitive guards for QXRead foundation contracts.
 */
export const VERSION_PATTERN = /^\d+\.\d+\.\d+$/;
export const TIMESTAMP_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
export function assertValidId(id, label) {
    if (typeof id !== 'string' || id.length === 0 || /\s/.test(id)) {
        throw new Error(`${label} must be a non-empty id without whitespace`);
    }
}
export function assertOptionalTrimmed(value, label) {
    if (value === undefined || value === null) {
        return null;
    }
    if (typeof value !== 'string' || value.trim().length === 0) {
        throw new Error(`${label} must be a non-empty string`);
    }
    return value.trim();
}
export function assertTimestamp(value, label) {
    if (typeof value !== 'string' || !TIMESTAMP_PATTERN.test(value)) {
        throw new Error(`${label} must be an ISO-8601 timestamp`);
    }
}
//# sourceMappingURL=guards.js.map